module.exports = __webpack_public_path__ + "img/app-business.05a2da5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_logos/app-business.svg
// module id = qrCk
// module chunks = 0